import { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { deleteUser, getUsers } from '../../redux/action';
import ItemListTableUser from '../itemListTableUser';
import ModalNoti from '../../../../components/modalNoti';
import './index.css';

const ITEM_PER_PAGE = 10;

function TableUser({projects, project, editUser}) {

	const [isShowDeletePopUp, setIsShowDeletePopUp] = useState(false);
	const [isShowFailPopUp, setIsShowFailPopUp] = useState(false);
	const [user, setUser] = useState(false);

	const [valuePage, setValuePage] = useState('');

	const dispatch = useDispatch();
  const [
    page,
    totalPage,
		totalUsers,
    users,
    isDeletedUserFail,
  ] = useSelector((state) => [
    state.manageUser.page,
    state.manageUser.totalPage,
		state.manageUser.totalUsers,
    state.manageUser.users,
    state.manageUser.isDeletedUserFail,
  ]);

	useEffect(() => {
		if(isDeletedUserFail){
			setIsShowFailPopUp(true);
		}

	},[isDeletedUserFail])

	useEffect(() => {
		setValuePage(page);

	},[page])

	return (
	  <div className='container' style={{minWidth: '90%'}}>
		
			<div className="main_table_search">
				<Table className="table_search">
					<thead>
						<tr>
							<th style={{width: '3%'}}><div className="middle">#</div></th>
							<th style={{width: '13%'}}><div className="middle">Email</div></th>
							<th style={{width: '15%'}}><div className="middle">Tên nhân viên</div></th>
							<th style={{width: '13%'}}><div className="middle">SDT nhân viên</div></th>
							<th style={{width: '10%'}}><div className="middle">Dự án</div></th>
							<th style={{width: '10%'}}><div className="middle">Bộ phận</div></th>
							<th style={{width: '12%'}}><div className="middle">Phân quyền</div></th>
							<th style={{width: '14%'}}><div className="middle">Ngày cập nhật phân quyền</div></th>
							<th style={{width: '14%'}}><div className="middle">Người phân quyền</div></th>
							<th>
								<div className="middle">Sửa</div>
							</th>
							<th>
								<div className="middle">Xóa</div>
							</th>
						</tr>
					</thead>
					<tbody>
						{users.map((user, index) => {
							return(
								<tr key={index}>
									<td><div className="middle">{(page * ITEM_PER_PAGE - ITEM_PER_PAGE) + index + 1}</div></td>
									<td> {user.email.split("@")[0]}<span style={{wordBreak:"keep-all"}}>@{user.email.split("@")[1]}</span></td>
									<td>{user.name}</td>
									<td style={{wordBreak:'inherit'}}>{user.phone}</td>
									<td>{user.project}</td>
									<td>{user.department}</td>
									<td style={{wordBreak:'inherit'}}><div className="middle">{user.role}</div></td>
									<td style={{wordBreak:'inherit'}}><div className="middle">{user.update_date}</div></td>
									<td> {user.update_by.split("@")[0]}<span style={{wordBreak:"keep-all"}}>@{user.update_by.split("@")[1]}</span></td>
									<td>
										<div className="middle">
											<img src="./dashboard/edit.png" alt="" onClick={() => editUser(user)}/>
										</div>
									</td>
									<td>
										<div className="middle">
											<img src="./dashboard/delete_2.png" alt="" onClick={() => {
												setUser(user);
												setIsShowDeletePopUp(true);
											}}/>
										</div>
									</td>
								</tr>
							)
						})}
					</tbody>
				</Table>

				<div className="row">
					<div className="col-12">
						<div className="list_table">
							{users.map((user, index) => {
								return (
									<ItemListTableUser
										key={index}
										user={user}
										editUser={() => editUser(user)}
										deleteUser={() => {
											setUser(user);
											setIsShowDeletePopUp(true);
										}}
									></ItemListTableUser>
								)
							})}
						</div>
					</div>
				</div>
				<div className="pagination">
					<div className="notification_result_search">{`Tìm thấy ${totalUsers} kết quả`}</div>
					{totalPage !== 1 && totalPage !== 0 &&
					<div className="pagination_item">
						<img 
							className={Number(page) === 1 ? 'block_page' : ''} 
							src="./dashboard/arrow_left_circle.png"
							alt=""
							onClick={() => {
								if(Number(page) !== 1)
								{

									setValuePage(Number(page) - 1);
									dispatch(getUsers({project: users.length > 0 ? users[0].project : project.account_name, page: Number(page) - 1}));
								}
							}}
						/>
						<input 
							className="page_current"
							placeholder={page}
							value={valuePage}
							onKeyDown={(e) => {
								if (e.key === 'Enter') {
									let value = e.target.value;
									if(isNaN(value)){
										dispatch(getUsers({project: users.length > 0 ? users[0].project : project.account_name, page: 1}));
										setValuePage(1);
									} else {
										if(value < 1){
											value = 1;
										}
										if(value > totalPage){
											value = totalPage;
										}
										dispatch(getUsers({project: users.length > 0 ? users[0].project : project.account_name, page: Number(value)}));
										setValuePage(value);
									}
								}
							}}
							onChange={(e) => {setValuePage(e.target.value);}}
						/>
						<span>/</span>
						<p className="page_total">{totalPage}</p>
						<img 
							className={Number(page) === Number(totalPage) ? 'block_page' : ''}
							src="./dashboard/arrow_right_circle.png"
							alt="" 
							onClick={() => {
								if(Number(page) !== Number(totalPage)){
									setValuePage(Number(page) + 1);
									dispatch(getUsers({project: users.length > 0 ? users[0].project : project.account_name, page: Number(page) + 1}))
								}
							}}
						/>
					</div>}
				</div>	
			</div>
			
			<ModalNoti
				show={isShowDeletePopUp}
				onHide={() => setIsShowDeletePopUp(false)}
				closeButton={false}
				content={`Bạn đang thao tác xóa nhân viên ${user.email}. Bạn có muốn tiếp tục?`}
				leftButton={{
					onClick: () => {
						setIsShowDeletePopUp(false);
					},
					content: "Đóng"
				}}
				rightButton={{
					onClick: () => {
						
						const findProject = projects.find(e => e.account_name === user.project);
						if(findProject){
							dispatch(deleteUser({email: user.email, project: findProject}));
						}
						
						setIsShowDeletePopUp(false);
					},
					content: "Xóa"
				}}
				>
			</ModalNoti>

			<ModalNoti
				show={isShowFailPopUp}
				onHide={() => setIsShowFailPopUp(false)}
				closeButton={false}
				content={"Xảy ra lỗi trong quá trình xử lý. Vui lòng thao tác lại"}
				leftButton={{
					onClick: () => {
						setIsShowFailPopUp(false);
					},
					content: "Đóng"
				}}
				rightButton={{
					onClick: () => {
						const findProject = projects.find(e => e.account_name === user.project);
						if(findProject){
							dispatch(deleteUser({email: user.email, project: findProject}));
						}
						setIsShowFailPopUp(false);
					},
					content: "Thử lại"
				}}
			>
			</ModalNoti>
	  </div>
	);
}
  
export default TableUser;